import { Capacitor } from '@capacitor/core';

// Custom apiRequest function that returns the json data directly
export async function apiRequest<T>(url: string, options?: RequestInit): Promise<T> {
  const token = localStorage.getItem("token");
  let newHeaders = { ...(options?.headers || {}) };

  if (token) {
    newHeaders = { ...newHeaders, Authorization: `Bearer ${token}` };
  }

  // Don't set Content-Type for FormData requests
  if (!(options?.body instanceof FormData)) {
    newHeaders = { ...newHeaders, "Content-Type": "application/json" };
  }

  const headers = newHeaders as Record<string, string>;

  // Handle absolute and relative URLs for mobile compatibility
  let fullUrl = url;
  if (url.startsWith('/') && !url.startsWith('//')) {
    // This is a relative URL, we need to prepend the base URL for mobile builds
    if (Capacitor.isNativePlatform() && import.meta.env.VITE_SERVER_URL) {
      fullUrl = `${import.meta.env.VITE_SERVER_URL}${url}`;
      console.log(`Mobile API request: Converting relative URL to absolute: ${fullUrl}`);
    }
  }

  const requestOptions: RequestInit = {
    ...options,
    headers,
  };

  const res = await fetch(fullUrl, requestOptions);

  if (!res.ok) {
    const text = await res.text();
    try {
      const errJson = JSON.parse(text);
      throw new Error(errJson.message ?? `${res.status}: ${text}`);
    } catch (error) {
      const err = error as Error;
      console.error('Error parsing error response:', err.message);
      throw new Error(`${res.status}: ${text ?? res.statusText}`);
    }
  }

  return res.json() as Promise<T>;
}
